import Box from "@mui/material/Box";
import { Divider } from "@mui/material";
import { COLOR_LIGHT_GREY } from "./theme";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import React from "react";

const Clients = ({ ref }) => {
  const clientListItem = (logoUrl, title, subtitle, url, ref) => {
    return (
      <Link
        href={url}
        underline="none"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Box
          px={3}
          py={1}
          maxWidth="100%"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            background: "#fff",
            border: "1px solid #e5e5e5",
            marginBottom: "1rem",
            borderRadius: 50,
            transition: "all 0.3s ease", // Animation transition
            "&:hover": {
              transform: "scale(1.01)", // Grow the item slightly
              backgroundColor: "#f0f0f0", // Darken the background on hover
              boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.2)", // Add a shadow
            },
            "@media (min-width: 450px)": {
              minWidth: "475px", // Hide on small screens (portrait)
            },
          }}
        >
          <img
            src={logoUrl}
            alt={logoUrl}
            width="44px"
            style={{
              borderRadius: 100,
              boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.3)",
            }}
          />
          <Box py={1} mr={4}>
            <Typography variant="subtitle2">
              {title.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: "Bold" }}
              ref={ref}
            >
              {subtitle}
            </Typography>
          </Box>
        </Box>
      </Link>
    );
  };

  return (
    <>
      <Box component="section" mb={4}>
        <Divider
          sx={{
            width: "100%",
            height: "1px",
            backgroundColor: COLOR_LIGHT_GREY,
            my: 2,
            opacity: 0.5,
          }}
        />

        <Box mb={3}>
          <Typography
            variant="h5"
            sx={{
              fontFamily: "Sanchez",
              maxWidth: "100%",
              whiteSpace: "normal",
              overflowWrap: "break-word",
            }}
          >
            Partenaires
          </Typography>
        </Box>
        <Box p={0}>
          {clientListItem(
            "/images/lichens_innovation_logo.jpg",
            "Développement web full stack",
            "Lichens Innovation",
            "https://www.lichens.ai/"
          )}
          {clientListItem(
            "/images/collectifdiapason_logo.jpg",
            "Développement web full stack",
            "Collectif Diapason",
            "https://collectifdiapason.com/collaborateur-trices/jonathan-girard/",
            ref
          )}
        </Box>
      </Box>
    </>
  );
};

export default Clients;
